<template>
  <div class="h-100p">
    <div class="ov-a mar-t-10f pad-t-20">
      <el-form
        class="pad-10"
        :model="ruleForm"
        ref="ruleForm"
        :disabled="doType == 'detail'"
        label-width="100px"
        label-position="top"
        size="small"
        :rules="rules"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="企业名称" prop="name">
              <el-input
                :disabled="doType == 'detail'"
                v-model="ruleForm.name"
                placeholder="请输入企业名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="统一社会信用代码"
              prop="uniform_social_credit_code"
            >
              <el-input
                :disabled="doType == 'detail'"
                placeholder="请输入统一社会信用代码"
                v-model="ruleForm.uniform_social_credit_code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="企业法人" prop="legal_person">
              <el-input
                placeholder="请输入企业法人"
                :disabled="doType == 'detail'"
                v-model="ruleForm.legal_person"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="企业类型" prop="type">
              <el-select
                v-model="ruleForm.type"
                size="small"
                placeholder="请选择企业类型"
              >
                <el-option
                  v-for="item in enterpriseTypes"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="企业规模" prop="firm_size">
              <el-select
                v-model="ruleForm.firm_size"
                placeholder="请选择企业规模"
              >
                <el-option
                  v-for="item in firmSizeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="roomForm">
            <el-form-item label="注册资金(万)" prop="registered_capital">
              <el-input
                placeholder="请输入注册资金"
                type="number"
                v-model.number="ruleForm.registered_capital"
                class="input-with-select"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="负责人" prop="principal">
              <el-input
                placeholder="请输入负责人姓名"
                v-model="ruleForm.principal"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话" prop="phone_num">
              <el-input
                placeholder="请输入联系电话"
                v-model="ruleForm.phone_num"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="所属楼宇" prop="building_id" label-width="80px">
              <el-select
                v-model="ruleForm.building_id"
                @change="handleBuildingChange"
              >
                <el-option
                  v-for="item in buildingList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属楼层" prop="floor_id" label-width="80px">
              <el-select v-model="ruleForm.floor_id" @change="handleFloorChange">
                <el-option
                  v-for="item in floorList"
                  :key="item.id"
                  :label="item.code"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属房间" prop="room_id" label-width="80px">
              <el-select v-model="ruleForm.room_id">
                <el-option
                  v-for="item in roomList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="注册状态" prop="status" label-width="80px">
              <el-select v-model="ruleForm.status">
                <el-option
                  v-for="item in virtualCompanyStatus"
                  :key="item.value"
                  :label="item.name"
                  :value="Number(item.value)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="注册地区" prop="registered_area">
              <el-input
                type="textarea"
                :disabled="doType == 'detail'"
                placeholder="请输入注册地区"
                :rows="2"
                v-model="ruleForm.registered_area"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="注册详细地址" prop="registered_address">
              <el-input
                :disabled="doType == 'detail'"
                type="textarea"
                :rows="2"
                placeholder="请输入注册详细地址"
                v-model="ruleForm.registered_address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="pad-l-15 pad-r-15">
        <el-divider content-position="left">营业执照</el-divider>
          <ManageFormFile class="pad-t-15 pad-b-15" :disabled="doType == 'detail'" v-model="ruleForm.business_license"></ManageFormFile>
          <el-divider content-position="left">其他资料</el-divider>
          <ManageFormFile class="pad-t-15 pad-b-15" :disabled="doType == 'detail'" v-model="ruleForm.attachment_id"></ManageFormFile>
      </div>
    </div>
    <div class="btnClass bor-t" v-if="doType != 'detail'">
      <el-button
        size="small"
        class="pull-right mar-l-10 mar-t-10"
        type=""
        @click="close"
        >取消</el-button
      >
      <el-button
        size="small"
        class="pull-right mar-t-10"
        type="primary"
        :loading="saveLoading"
        @click="handleSubmit"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import * as dictbizService from "@/api/system/dictbiz";

import {
  saveMetaCommon,
  updateMetaCommon,
  getPicListByIds,
  getMetaCommonList,
} from "@/api/busiMode/metaCommon";
import { validatePhone } from "@/api/visitor/visitor";
import ManageFormFile from "./../contract/manageFormFile.vue";

export default {
  name: "addEnterprise",
  components:{ManageFormFile},
  data() {
    return {
      model: "wisdom_park.wp_virtual_company",
      rules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        uniform_social_credit_code: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        principal: [
          { required: true, message: "请输入负责人", trigger: "blur" },
        ],
        phone_num: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        building_id: [{ required: true, message: "请选择楼宇"}],
        floor_id: [{ required: true, message: "请选择楼层"}],
        room_id: [{ required: true, message: "请选择房间"}],
      },
      ruleForm: { name: "", industry_chain: "5",attachment_id:"",status: 1 },
      enterpriseTypes: [],
      firmSizeList: [],
      virtualCompanyStatus:[],
      ruleModel: {},
      saveLoading: false,
      buildingList: [],
      floorList: [],
      roomList: [],
      modelKeys:['id','name','uniform_social_credit_code','legal_person','type','firm_size','registered_capital','principal','phone_num','building_id', 'building_name','floor_id', 'floor_name','room_id','room_name','status','registered_area','registered_address','business_license','attachment_id']
    };
  },
  props: {
    currentRow: {
      type: Object,
      default() {
        return {};
      },
    },
    doType: {
      type: String,
      default() {
        return "";
      },
    },
  },
  beforeMount() {
    this.getBuildingList();
    this.getDicList();
    if(this.currentRow.id) {
      this.handleBuildingChange(this.currentRow.building_id)
      this.handleFloorChange(this.currentRow.floor_id)
    }
  },
  watch: {
    currentRow: {
      immediate: true,
      handler(val) {
        this.ruleForm = val;
      },
    },
  },
  methods: {
    /** 获取楼宇列表 */
    getBuildingList() {
      getMetaCommonList("wisdom_park.wp_building", {
        size: 20,
        orders: [{ field: "sort", sort: "ASC" }],
      }).then(({ data }) => {
        if (data.success) {
          this.buildingList = data.data.records;
          
        }
      });
    },

    /**
     * 监听楼宇选择变化
     */
    handleBuildingChange(val) {
      getMetaCommonList("wisdom_park.wp_floor", {
        orders: [{ field: "code", sort: "ASC" }],
        wheres: [{ field: "building_id", value: val }],
        size: 50,
      }).then(({ data }) => {
        if (data.success) {
          this.floorList = data.data.records;
        }
      });
    },
    /**
     * 监听楼层选择变化
     */
    handleFloorChange(val) {
      getMetaCommonList("wisdom_park.wp_room", {
        orders: [{ field: "name", sort: "ASC" }],
        wheres: [
          { field: "floor_id", value: val },
          { field: "is_cancel", value: "0" },
        ],
        size: 50,
      }).then(({ data }) => {
        if (data.success) {
          this.roomList = data.data.records;
        }
      });
    },

    /** 根据数据字典获取下拉框数据 */
    getDicList() {
      dictbizService.getDictionary({ code: "firmSize" }).then((res) => {
        this.firmSizeList = (res.data.data || []).map((item) => {
          return {
            name: item["dictValue"],
            value: item["dictKey"],
          };
        });
      });
      dictbizService.getDictionary({ code: "enterpriseType" }).then((res) => {
        this.enterpriseTypes = (res.data.data || []).map((item) => {
          return {
            name: item["dictValue"],
            value: item["dictKey"],
          };
        });
      });
       dictbizService.getDictionary({ code: "virtualCompanyStatus" }).then((res) => {
        this.virtualCompanyStatus = (res.data.data || []).map((item) => {
          return {
            name: item["dictValue"],
            value: item["dictKey"],
          };
        });
      });
    },
    close() {
      this.$emit("close");
    },
    /** 保存或提交 */
    handleSubmit() {
      this.$refs.ruleForm.validate((err) => {
        if (err) {
          /** 查询后台手机号码是否唯一 */
          validatePhone({ phoneNum: this.ruleForm.phone_num }).then(
            ({ data }) => {
              if ((!this.ruleForm.id && data.data > 0) || (this.ruleForm.id && data.data > 1)) {
                this.$message.error("联系人电话不是唯一");
                this.saveLoading = false;
                return;
              } else {
                let data = {}
                Object.keys(this.ruleForm).forEach(key => {
                  if(this.modelKeys.includes(key)) {
                    data[key] = this.ruleForm[key]
                  }
                })
            for (let index = 0; index < this.buildingList.length; index++) {
              if(data.building_id ==  this.buildingList[index].id) {
                data.building_name = this.buildingList[index].name
                break
              }
            }
            for (let index = 0; index < this.floorList.length; index++) {
              if(data.floor_id ==  this.floorList[index].id) {
                data.floor_name = this.floorList[index].code
                break
              }
            }
            for (let index = 0; index < this.roomList.length; index++) {
              if(data.room_id ==  this.roomList[index].id) {
                data.room_name = this.roomList[index].name
                break
              }
            }
                let body = this.ruleForm.id ?  {
                  update: data,
                  primaryKeyValue: this.ruleForm.id,
                  primaryKey: "id"
                } : {values:data};
                (this.ruleForm.id ? updateMetaCommon : saveMetaCommon)(this.model, body).then((res) => {
                  if (res.data.success) {
                    this.$emit("close");
                  }
                });
              }
            }
          );
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btnClass {
  display: flow-root;
  height: 50px;
  line-height: 50px;
  padding: 0px 15px;
}
/deep/ .el-dialog__body {
  padding-top: 0px;
}
.titleactive {
  color: #475570 !important;
}
.title {
  color: #8d9ab2;
}
.p-a {
  position: absolute;
}
.diaTitle {
  top: 23px;
  left: 80px;
}
.diaDiv {
  height: 55vh;
  overflow-x: hidden !important;
}
.drawerDiv {
  height: calc(100% - 50px);
  overflow-x: hidden !important;
}
.titlediv {
  background: #fff;
  padding: 20px;
}
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  // line-height: 72px;
  // vertical-align: top;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
/deep/ .el-select {
  width: 100%;
}
</style>
